// פרט מ-siteInfo.js בתוך טקסט משפטי. ריק → סימון צהוב בולט "[יש להשלים]", כדי שלא יתפרסם בלי שמולא
const missing = { background: '#fff8c5', color: '#7d4e00', padding: '0 4px', borderRadius: 4, fontWeight: 600 };

const Fill = ({ value }) => (value ? <>{value}</> : <span style={missing}>[יש להשלים]</span>);

export default Fill;
